import { render } from "./TheTag.vue?vue&type=template&id=54d6b8de&ts=true"
import script from "./TheTag.vue?vue&type=script&lang=ts"
export * from "./TheTag.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src205726665/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__